import React, 
      { useState , 
        useEffect,
        useRef , }        from 'react'
import Grid              from '@mui/material/Grid'
import Box               from '@mui/material/Box'
import Typography        from '@mui/material/Typography'
import Paper             from '@mui/material/Paper'
import TextField         from '@mui/material/TextField'
import Dialog            from '@mui/material/Dialog'
import DialogActions     from '@mui/material/DialogActions'
import DialogContent     from '@mui/material/DialogContent'
import DialogContentText from '@mui/material/DialogContentText'
import DialogTitle       from '@mui/material/DialogTitle'
import Button            from '@mui/material/Button'
import axios             from 'axios'
import store             from '../../store'
import '../../App.css'
import '../../style.css';
import {MUSIC_GAME,
        MUSIC_POKEMON_BATLE,
        MUSIC_POKEMON_VICTORY,
        IMG_MONSTER_BALL,
        IMG_SUPER_BALL,
        IMG_HYPER_BALL,
        IMG_MASTER_BALL,} from '../Contants'
import ZukanSavedDialog   from "./Dialog"

function GameMain() {
  const [pokemonImage     , setPokemonImage     ] = useState(IMG_MONSTER_BALL) // ポケモン画像表示
  const [pokemonname      , setPokemonName      ] = useState()             // ポケモンの名前
  const [pokemonhight     , setPokemonHight     ] = useState()             // ポケモンの高さ
  const [pokemonweight    , setPokemonWeight    ] = useState()             // ポケモンの重さ
  const [pokemontext      , setPokemonText      ] = useState()             // ポケモンの説明文
  const [pokemonid        , setPokemonID        ] = useState()             // ポケモンのNo
  const [pokemongenus     , setPokemonGenus     ] = useState()             // ポケモンの分類
  const [showRadioGroup   , setShowRadioGroup   ] = useState(true)         // ラジオグループの表示コントロール
  const [frontNum         , setFrontNum         ] = useState(0)            // かける数を代入
  const [backNum          , setBackNum          ] = useState(0)            // かけられる数を代入
  const [value            , setValue            ] = useState()             // 答えのテキストボックスに入力している値
  const [resultWord       , setResultWord       ] = useState()             // 正解 or 不正解の判定
  const [fontColor        , setFontColor        ] = useState()             // フォントカラー
  const [count            , setCount            ] = useState(1)            // 問題数
  const [dialogopen       , setDialogOpen       ] = useState(false)        // ダイアログ表示の状態管理
  const [correctCount     , setCorrectCount     ] = useState(0)            // 正解の数
  const [getPokemonList   , setGetPokemonList   ] = useState([])           // 正解したポケモンの画像を格納する配列
  const [localpokemondata , setLocalPokemonData ] = useState([])

  var useEffectCount = 0  // useEffectのカウンタ
  // 音楽が流れる
  const [gameMusic]       = useState(new Audio(MUSIC_GAME))
  const [battleAudio]     = useState(new Audio(MUSIC_POKEMON_BATLE))
  const [pokemonVictory ] = useState(new Audio(MUSIC_POKEMON_VICTORY))
  // 図鑑保存ダイアログ用
  const [savedDialogOpen, setSavedDialogOpen] = useState(false)
  const [savedDialogMessage, setSavedDialogMessage] = useState("図鑑に登録しました。")

  useEffect(() => {
    console.log("選択中のゲームモード=>",store.getState().GameModeSelect)
    console.log("選択中の計算式:",store.getState().CalcSelect)
    
    // 1秒待機する
    setTimeout(() => {
      console.log("★" , useEffectCount);
      useEffectCount = useEffectCount+1
      // useEffectが2回呼び出される？ため、２回目のみ処理を起動する
      if(useEffectCount === 1){
        startPokemonBatlePlay()  // 再生
        // ポケモンを呼び出す
        fetchPokemonImages()
        // 前項の取得
        let front = Math.floor(Math.random() * 10) + 1
        // 後項の取得
        let back = Math.floor(Math.random() * 9) + 1
        
        // 前項が後項以下の場合、前項が後項よりも大きくなるまで再試行する
        while (front <= back) {
          front = Math.floor(Math.random() * 10) + 1
          console.log("front:" , front)
          console.log("back:" , back)
          console.log("--------------")
        }
        
        setFrontNum(front)
        setBackNum(back)
        }

    }, 1000) // 500ミリ秒 = 0.5秒待機

  }, [])

  // ポケモンAPIを呼び出す
  const fetchPokemonImages = async () => {
    // ポケモンAPIを呼び出す
    const randomNumber = Math.floor(Math.random() * 898) + 1
    // ポケモンAPIを呼び出す
    const response = await axios.get("https://pokeapi.co/api/v2/pokemon/" + randomNumber)    

    // ポケモンの画像を取得
    setPokemonImage(response.data.sprites.front_default)

    // 高さを取得
    setPokemonHight(response.data.height)

    // 重さを取得
    setPokemonWeight(response.data.weight)

    // Noを取得
    setPokemonID(response.data.id)
    const speciesUrl = response.data.species.url
    const speciesResponse = await axios.get(speciesUrl)

    // 分類を取得
    const genera = speciesResponse.data.genera || []
    const genusObj =
        genera.find(v => v?.language?.name === "ja-Hrkt") ||
        genera.find(v => v?.language?.name === "ja") ||
        genera.find(v => v?.language?.name === "en")
    setPokemonGenus(genusObj?.genus ?? "")

    // ポケモンの名前を取得
    const japaneseName = speciesResponse.data.names.find(name => name.language.name === "ja").name
    setPokemonName(japaneseName)

    // 説明文取得
    const flavorTextEntries = speciesResponse?.data?.flavor_text_entries || [];
    const pickFlavor = (lang, version) =>
      flavorTextEntries.find(
        (v) => v?.language?.name === lang && v?.version?.name === version
      )?.flavor_text;
    const cleanedText =
      pickFlavor("ja-Hrkt", "sword") ||
      pickFlavor("ja", "sword") ||
      pickFlavor("ja-Hrkt", "y") ||
      pickFlavor("ja", "y") ||
      pickFlavor("ja-Hrkt", "sun") ||
      pickFlavor("ja", "sun") ||
      pickFlavor("ja-Hrkt", "ultra-sun") ||
      pickFlavor("ja", "ultra-sun") ||
      "ポケモンのデータがありませんでした。";

    setPokemonText(cleanedText);
  }

  // バトル音楽を再生
  const startPokemonBatlePlay = () => {
    gameMusic.pause()       // 停止
    battleAudio.pause()     // 停止
    pokemonVictory.pause()  // 停止
    battleAudio.currentTime = 0 // 常に先頭から再生
    // 1秒待機する
    setTimeout(() => {
      battleAudio.play() // 再生
    }, 500) // 500ミリ秒 = 0.5秒待機
  }

  // 勝利音楽を再生
  const startPokemonVictoryPlay = () => {
    gameMusic.pause()       // 停止
    battleAudio.pause()     // 停止
    pokemonVictory.pause()  // 停止
    pokemonVictory.currentTime = 0 // 常に先頭から再生
    // 1秒待機する
    setTimeout(() => {
      pokemonVictory.play() // 再生
    }, 500) // 500ミリ秒 = 0.5秒待機
  }

  // 音楽をすべて停止
  const AllMusicPause = () => {
    gameMusic.pause()       // 停止
    battleAudio.pause()     // 停止
    pokemonVictory.pause()  // 停止
  }

  // 初期値に戻す
  const initialize = () => {
    setShowRadioGroup(true)
    setPokemonImage("")
    setPokemonName("")
    setCount(1)
    setFontColor("")
    setResultWord("")
    setValue("")
    setCorrectCount(0)
    setGetPokemonList([])
  }
  
  // ダイアログを開く
  const handleDialogOpen = () => {
    setDialogOpen(true)

    startPokemonVictoryPlay() // 再生
  }

  // ダイアログを閉じる
  // もう一度ゲームをやる
  const handleGameReturn = () => {
    setDialogOpen(false)
    // 初期状態に戻す
    initialize(true)

    startPokemonBatlePlay()  // 再生
    // ポケモンを呼び出す
    fetchPokemonImages()
    // 前項の取得
    let front = Math.floor(Math.random() * 10) + 1
    // 後項の取得
    let back = Math.floor(Math.random() * 9) + 1
    
    // 前項が後項以下の場合、前項が後項よりも大きくなるまで再試行する
    while (front <= back) {
      front = Math.floor(Math.random() * 10) + 1
      console.log("front:" , front)
      console.log("back:" , back)
      console.log("--------------")
    }
    
    setFrontNum(front)
    setBackNum(back)
  }

  // ダイアログを閉じる
  // リフレッシュする
  const handleGameReflesh = () => {
    setDialogOpen(false)
    // 初期状態に戻す
    initialize(true)

    window.location.reload() // 画面をリフレッシュする
  }

  // テキストボックスの内容
  const handleChange = (event) => {
    // 入力された値が数字でない場合は削除します
    const inputValue = event.target.value.replace(/[^0-9]/g, '')
    setValue(inputValue)
  }

  // 答えが入力された時の処理
  const handleKeyPressResult = (event) => {
    // ポケモン情報をオブジェクトとしてまとめる
    const newPokemon  = {
      id     : pokemonid     ,
      name   : pokemonname   ,
      image  : pokemonImage  ,
      height : pokemonhight  ,
      weight : pokemonweight ,
      genus  : pokemongenus  ,
      text   : pokemontext   ,
    }
    if (event.key === 'Enter') {
      console.log("入力値 => ",event.target.value)

      switch (store.getState().CalcSelect) {
        case 'tashi':
          if (event.target.value == frontNum + backNum) {
            console.log("正解")
            setResultWord("せいかい！GET！！")  // 結果のメッセージ
            setFontColor("red")                // フォントカラー設定

            // 配列に加える
            setGetPokemonList(prevList => {
              const newList = [...prevList, newPokemon]
              console.log("getPokemonList : ", newList, newList.length)
              return newList
            })

            setCorrectCount(correctCount + 1)    // 正解数を増加
            setPokemonImage(IMG_MONSTER_BALL) // 画像をモンスターボールに変更
          } else {
            console.log("不正解")
            setFontColor("blue")              // フォントカラー設定
            setResultWord("にげられた。。。")  // 結果メッセージ
          }
          break

        case 'hiki':
          if (event.target.value == frontNum - backNum) {
            console.log("正解")
            setResultWord("せいかい！GET！！")  // 結果のメッセージ
            setFontColor("red")                // フォントカラー設定

            // 配列に加える
            setGetPokemonList(prevList => {
              const newList = [...prevList, newPokemon]
              console.log("getPokemonList : ", newList, newList.length)
              return newList
            });

            setCorrectCount(correctCount + 1)    // 正解数を増加
            setPokemonImage(IMG_MONSTER_BALL) // 画像をモンスターボールに変更
          } else {
            console.log("不正解")
            setFontColor("blue")              // フォントカラー設定
            setResultWord("にげられた。。。")  // 結果メッセージ
          }
          break

        case 'kake':
        if (event.target.value == frontNum * backNum) {
          console.log("正解")
          setResultWord("せいかい！GET！！")  // 結果のメッセージ
          setFontColor("red")                // フォントカラー設定

          // 配列に加える
          setGetPokemonList(prevList => {
            const newList = [...prevList, newPokemon]
            console.log("getPokemonList : ", newList, newList.length)
            return newList
          })

          setCorrectCount(correctCount + 1)    // 正解数を増加
          setPokemonImage(IMG_MONSTER_BALL) // 画像をモンスターボールに変更
        } else {
          console.log("不正解")
          setFontColor("blue")              // フォントカラー設定
          setResultWord("にげられた。。。")  // 結果メッセージ
        }
        break

        default:
          break
      }
      
      // カウントアップ
      setCount(count+1)
      console.log("count => " , count)
      // 10問で終了、終了後は処置期画面へ
      if(count == 10){

      // 2秒待機する
      setTimeout(() => {
        console.log("終了")

        // ダイアログを表示する
        handleDialogOpen(true)

      }, 2000); // 2000ミリ秒 = 2秒待機

      }else{
        // ポケモンを再取得
        fetchPokemonImages()

        // 2秒待機する
        setTimeout(() => {

          setResultWord("")
          setValue("")

          // 前項の取得
          let front = Math.floor(Math.random() * 10) + 1
          // 後項の取得
          let back = Math.floor(Math.random() * 9) + 1
          
          // 前項が後項以下の場合、前項が後項よりも大きくなるまで再試行する
          while (front <= back) {
            front = Math.floor(Math.random() * 10) + 1
            console.log("front:" , front)
            console.log("back:" , back)
            console.log("--------------")
          }
          
          setFrontNum(front)
          setBackNum(back)

        }, 1000) // 2000ミリ秒 = 2秒待機
      }
    }
  }

  // エンターキーが押された時の処理
  const handleKeyPress = (event) => {
    // yes or no を選択
    console.log(event.target.value)
    
    // Enterキーが押された時は非表示にする
    if (event.key === 'Enter') {
      // yes or no の判定
      if(event.target.value == "yes"){
        console.log("yesが選択された！")

        // ポケモンAPIを呼び出す
        fetchPokemonImages()

        // 前項の取得
        let front = Math.floor(Math.random() * 10) + 1
        // 後項の取得
        let back = Math.floor(Math.random() * 9) + 1
        
        // 前項が後項以下の場合、前項が後項よりも大きくなるまで再試行する
        while (front <= back) {
          front = Math.floor(Math.random() * 10) + 1
          console.log("front:" , front)
          console.log("back:" , back)
          console.log("--------------")
        }
        
        setFrontNum(front)
        setBackNum(back)

        // ラジオボタン表示を消す
        setShowRadioGroup(false)
      }else{
        console.log("noが選択された！")
        // 画面をリフレッシュする
        window.location.reload() // 画面をリフレッシュする
      }
    }
  }

  // ローカルストレージに保存
  const handleSaveLocalStrage = () => {

    // 初期状態でローカルストレージから既存のデータを取得
    let existingPokemonData
    try {
      existingPokemonData = JSON.parse(localStorage.getItem('pokemondata'))
      // データがnullの場合や配列でない場合、空の配列を設定
      if (!Array.isArray(existingPokemonData)) {
        existingPokemonData = []
      }
    } catch (error) {
      console.error("データ取得に失敗しました。：", error)
      existingPokemonData = []
    }

    // ポケモンリストを追加する処理
    for (var i = 0; i < getPokemonList.length; i++) {
      // 既存のデータに新しいデータを追加
      existingPokemonData.push(getPokemonList[i])
    }

    // 更新されたデータを一度だけローカルストレージに保存
    try {
      localStorage.setItem('pokemondata', JSON.stringify(existingPokemonData))
      // 保存完了ダイアログを表示
      setSavedDialogMessage("図鑑に登録しました。")
      setSavedDialogOpen(true)
    } catch (error) {
      console.error("Failed to save data to localStorage:", error)
      // 失敗時の表示
      setSavedDialogMessage("保存に失敗しました…")
      setSavedDialogOpen(true)
    }

    // 最終的なデータをコンソールに出力
    console.log(existingPokemonData)
  }

  return (
      <Box sx={{ m : 1 , p : 4}}>
        {/* ダイアログの表示領域 */}
        <ZukanSavedDialog
          open={savedDialogOpen}
          message={savedDialogMessage}
          onClose={() => setSavedDialogOpen(false)}
          />
        {/* 画面 */}
        <Paper sx={{ m: 1, p: 1 ,
                bgcolor      : '#f5f5dc'  ,
                borderRadius : "1px"      , 
                height       : "250px"    ,
                width        : '250px'    ,
                position     : 'absolute' , // 絶対位置指定
                top          : '20px'     , // 縦位置を50pxに指定
                left         : '40px'     , // 横位置を20pxに指定
        }}>
            <Grid container spacing={0}>

              {/* ダイアログ表示 */}
              <Dialog
                open={dialogopen}
                onClose={handleGameReturn}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description">
                <DialogTitle id="alert-dialog-title">
                  <Grid container spacing={2}>
                    <Grid item xs={12} align="center">
                      <Typography
                        sx={{
                        // 独自フォントに設定
                        fontFamily   : 'DotGothic16'   , // Kalamフォント
                        fontSize     : "25px"    , 
                        color        : '#000000' , // フォントの色を黒に設定
                        }}>うまく入力できたかな？
                      </Typography>
                    </Grid>
                  </Grid>
                </DialogTitle>
                <DialogContent>
                  <DialogContentText id="alert-dialog-description">
                    <Grid container spacing={2}>
                      <Grid item xs={12} align="center">
                        <Typography
                          sx={{
                          // 独自フォントに設定
                          fontFamily   : 'DotGothic16'   , // Kalamフォント
                          fontSize     : "16px"    , 
                          color        : '#000000' , // フォントの色を黒に設定
                          }}>正しく入力できたかず
                        </Typography>
                      </Grid>
                      <Grid item xs={12} align="center">
                        <Typography
                          sx={{
                          // 独自フォントに設定
                          fontFamily   : 'DotGothic16'   , // Kalamフォント
                          fontSize     : "27px"    , 
                          color        : '#000000' , // フォントの色を黒に設定
                          }}>{correctCount} もん
                        </Typography>
                      </Grid>
                      <Grid item xs={12} align="center">
                      <Typography
                          sx={{
                          // 独自フォントに設定
                          fontFamily   : 'DotGothic16'   , // Kalamフォント
                          fontSize     : "16px"    , 
                          color        : '#000000' , // フォントの色を黒に設定
                          }}>↓↓↓↓↓ゲットしたポケモン↓↓↓↓↓</Typography>
                      </Grid>
                      {/* ポケモン画像表示 */}
                      {getPokemonList.map((getPokemonList , index) => (
                        <Grid item xs = {3} align="center">
                          <Button>
                            <img
                              key    = {index}
                              src    = {getPokemonList.image}
                              width  = "130px"
                              />
                          </Button>
                        </Grid>
                      ))}
                    </Grid>
                  </DialogContentText>
                </DialogContent>
                <DialogActions>
                <Grid container spacing={2}>
                  <Grid item xs = {4} align="center">
                    <Button onClick={handleGameReflesh}>
                      <img
                      src    = {IMG_SUPER_BALL}
                      width  = "50px"
                      height = "50px"/>
                    </Button>
                    <Typography
                      sx={{
                      // 独自フォントに設定
                      fontFamily   : 'DotGothic16'   , // Kalamフォント
                      fontSize     : "16px"    , 
                      color        : '#000000' , // フォントの色を黒に設定
                      }}>はじめのがめん</Typography>
                  </Grid>

                  <Grid item xs = {4} align="center">
                    <Button 
                      onClick={handleGameReturn} >
                      <img
                        src    = {IMG_HYPER_BALL}
                        width  = "50px"
                        height = "50px"/>
                    </Button>
                    <Typography
                      sx={{
                      // 独自フォントに設定
                      fontFamily   : 'DotGothic16'   , // Kalamフォント
                      fontSize     : "16px"    , 
                      color        : '#000000' , // フォントの色を黒に設定
                      }}>もういちど</Typography>
                  </Grid>

                  <Grid item xs = {4} align="center">
                    <Button 
                      onClick={handleSaveLocalStrage}>
                      <img
                        src    = {IMG_MASTER_BALL}
                        width  = "50px"
                        height = "50px"/>
                    </Button>
                    <Typography
                      sx={{
                      // 独自フォントに設定
                      fontFamily   : 'DotGothic16'   , // Kalamフォント
                      fontSize     : "16px"    , 
                      color        : '#000000' , // フォントの色を黒に設定
                      }}>ずかんにとうろくする</Typography>
                  </Grid>
                </Grid>
                </DialogActions>
              </Dialog>

                {/* タイトル表示 */}
                <Grid item xs={12} align="center">
                  <Typography
                    sx={{
                    // 独自フォントに設定
                    fontFamily   : 'DotGothic16'   , // Kalamフォント
                    fontSize     : "27px"    , 
                    color        : '#000000' , // フォントの色を黒に設定
                    }}>けいさんもんだい</Typography>
                </Grid>

                {/* ポケモン表示 */}
                <Grid item xs={12} align="center">
                  <img
                  src    = {pokemonImage}
                  width  = "100px"
                  height = "100px"/>
                </Grid>

                {/* 計算問題 表示 */}
                {/* 前項の表示 */}
                <Grid item xs={2} align="center" sx={{mt : -2}}>
                  <Typography
                    sx={{
                      // 独自フォントに設定
                      fontFamily   : 'DotGothic16'   , // フォント
                      fontSize     : "25px"          , 
                      color        : '#000000'       , // フォントの色を黒に設定
                      }}>{frontNum}</Typography>
                </Grid>
                <Grid item xs={2} align="center" sx={{mt : -2}}>
                  <Typography
                    sx={{
                      // 独自フォントに設定
                      fontFamily   : 'DotGothic16'   , // フォント
                      fontSize     : "25px"          , 
                      color        : '#000000'       , // フォントの色を黒に設定
                      }}>
                        {store.getState().CalcSelect === 'tashi' ? ' ＋ ' 
                        : store.getState().CalcSelect === 'hiki' ? ' - ' 
                        : ' × '}</Typography>
                </Grid>
              {/* 後項の表示 */}
                <Grid item xs={2} align="center" sx={{mt : -2}}>
                  <Typography
                    sx={{
                      // 独自フォントに設定
                      fontFamily   : 'DotGothic16'   , // フォント
                      fontSize     : "25px"          , 
                      color        : '#000000'       , // フォントの色を黒に設定
                      }}>{backNum}</Typography>
                </Grid>
                <Grid item xs={2} align="center" sx={{mt : -2}}>
                  <Typography
                    sx={{
                      // 独自フォントに設定
                      fontFamily   : 'DotGothic16'   , // フォント
                      fontSize     : "25px"          , 
                      color        : '#000000'       , // フォントの色を黒に設定
                      }}>=</Typography>
                </Grid>
              {/* 答えのInputBox表示 */}
                <Grid item xs={4} align="center" sx={{mt : -2}}>
                  <TextField 
                    variant="outlined"
                    size="small"
                    value={value}
                    onChange={handleChange}
                    autoFocus
                    onKeyDown={handleKeyPressResult} // Enterキーを押したときのイベントハンドラ
                    sx={{
                      fontFamily: 'DotGothic16',
                      fontSize: "25px",
                      color: '#000000',
                    }}/>
                </Grid>

                <Grid item xs={12} align="center">
                  <Typography
                    sx={{
                      // 独自フォントに設定
                      fontFamily   : 'DotGothic16'   , // フォント
                      fontSize     : "12px"          , 
                      color        : '#000000'       , // フォントの色を黒に設定
                      }}>※数字を入力してEnterキーで決定</Typography>
                </Grid>

                {/* メッセージ欄表示 */}
                <Grid 
                  item xs={12} 
                  align="center"
                  sx={{
                    border       : '3px solid #696969', // 枠線の太さと色を設定
                    borderRadius : '5px'           , // 角丸の半径を設定
                    padding      : '0 5px'         , // 上下0px、左右20pxの余白を設定
                    top          : '200px'         , // 縦位置を指定
                    left         : '5px'           , // 横位置を指定
                    position     : 'absolute'      , // 絶対位置指定
                    width        : '96%'           , // 外枠の幅を指定
                    height       : '23%'           , // 外枠の高さを指定
                    }}>

                    <Typography
                      sx={{
                        // 独自フォントに設定
                        fontFamily   : 'DotGothic16'   , // フォント
                        fontSize     : "14px"          , 
                        color        : '#000000'       , // フォントの色を黒に設定
                        }}
                      onKeyDown={handleKeyPress} // Enterキーを押したときのイベントハンドラ
                      tabIndex={0} // キーボードフォーカス可能にする
                      >{pokemonname} があらわれた！<br/>
                      <span style={{ color: fontColor, fontSize: '20px' }}>{resultWord}</span></Typography>
                </Grid>
            </Grid>
        </Paper>
    <Grid container spacing={2}>
        <Grid item xs={12} align="center"></Grid>
    </Grid>
    </Box>
  );
}

export default GameMain;
